import apisauce from 'apisauce'
import LocalStorage from './LocalStorage'
import { Config } from '../Global'
// import moment from 'moment'
// import { jwtDecode } from 'jwt-decode'

const Api = {}
const storage = LocalStorage.get('jwt')
Api.jwt = storage || null

const getClient = () => apisauce.create({
  baseURL: Config.API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: Api.jwt
  }
})

let client = getClient()

Api.get = async (url, params) => {
  try {
    return await client.get(url, params)
  } catch (err) {
    return { ok: false, error: err }
  }
}

Api.patch = async (url, data) => {
  try {
    return await client.patch(url, data)
  } catch (err) {
    return { ok: false, error: err }
  }
}

Api.put = async (url, data) => {
  try {
    return await client.put(url, data)
  } catch (err) {
    return { ok: false, error: err }
  }
}

Api.post = async (url, data) => {
  try {
    const res = await client.post(url, data)
    return res
  } catch (err) {
    return { ok: false, error: err }
  }
}

Api.delete = async (url) => {
  try {
    return await client.delete(url)
  } catch (err) {
    return { ok: false, error: err }
  }
}

Api.setToken = (jwt) => {
  Api.jwt = jwt ? `Bearer ${jwt}` : null
  client = getClient()
}

Api.finishSession = (res) => {
  if (!res || !res.ok) return false
  Api.setToken(res.data.accessToken)
  return { user: res.data.user, jwt: res.data.accessToken }
}

Api.login = async (email, password) => {
  try {
    const res = await client.post('/authentication', { email, password })
    if (!res.ok) return false
    if (res.data.setupToken) Api.setToken(res.data.setupToken)
    return res.data
  } catch (err) {
    return false
  }
}

Api.loginOtp = async (challengeToken, otp) => {
  try {
    return Api.finishSession(await client.post('/authentication/otp', { challengeToken, otp }))
  } catch (err) {
    return false
  }
}

Api.upload = async (url, formData) => {
  try {
    // Se formData non è passato, url è il formData (retrocompatibilità)
    if (!formData) {
      formData = url
      url = '/upload'
    }
    const response = await client.post(url, formData)
    return response
  } catch (err) {
    return { ok: false, error: err }
  }
}

// Api.check = async () => {
//   try {
//     if (window.location.pathname !== '/') {
//       const jwt = LocalStorage.get('jwt')
//       const { _id } = LocalStorage.get('user')
//       if (jwt) {
//         const valid = moment.unix(jwtDecode(jwt).exp) - moment() > 0
//         if (!valid) {
//           window.location.replace('/')
//         } else {
//           const res = await Api.get(`users/${_id}`)
//           if (res.ok && res.data) {
//             const user = res.data
//             const { azienda, role, intestazione } = user
//             LocalStorage.set('user', user)
//             if (role === 'azienda') {
//               LocalStorage.set('intestazione', intestazione)
//             } else if (role !== 'proprietario') {
//               const res = await Api.get(`users/${azienda}`)
//               if (res.ok && res.data) {
//                 const { intestazione } = res.data
//                 LocalStorage.set('intestazione', intestazione)
//               }
//             }
//           }
//         }
//       } else {
//         window.location.replace('/')
//       }
//     }
//   } catch (error) {}
// }

export default Api
